import React from "react";
import { useState } from "react";
import Spinner from "../../common/Spinner/Spinner";
import { ControlledInput } from "../../common/Input/Input";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import Checkbox from "../../common/Checkbox/Checkbox";
import { Button } from "../../common/Button/Button";
import { ArrowLeft} from "react-feather";

export default function CreatePackageCatalogue(props)
{
    return(

        <div className={`row row-container ${props.isLoading && "set-opacity"}`}>
        {props.isLoading && <Spinner className="center-screen" />}
        <div className="col-12 row-margin-10px">
            <span style={{cursor:"pointer"}} onClick={props.onCancelCreatePackageCatalogue}>
            <ArrowLeft style={{marginRight:"10px"}}/>
            </span>
            {props.isEditPackageCatalogue?
            (
                <label>
                    <b>Edit Package/Offering</b>
                </label>):
            (
                <label>
                    <b>Create Package/Offering</b>
                </label>
            )}            
        </div>
        <div className="col-12">
            <div className='form-group'>
                <div className="row">
                    <div className="col-7">
                        <div className="row">
                            <div className="col-4">
                                <label style={{marginBottom:"10px"}}>Package/Offering Title <span className="required">*</span></label><br/>
                                    <ControlledInput
                                        name="sPackageOfferTitle"
                                        placeholder="Package/Offering Title"
                                        value={props.packageCatalogueData.sPackageOfferTitle || ""}
                                        onChange={({ target: { name, value } }) =>props.onInputChange(name, value)}
                                        autoComplete="off"
                                    />
                            </div>
                            <div className="col-4 datepicker-full">
                                <label style={{marginBottom:"10px"}}>Start Date <span className="required">*</span></label><br/>
                                <ReactDatePicker
                                    placeholderText="Start Date"
                                    className="col-12"
                                    dateFormat="dd/MM/yyyy"
                                    selected={props.packageCatalogueData.dtStartDate || ""}
                                    onChange={(date) => props.onInputChange("dtStartDate", date) }
                                />
                            </div>
                            <div className="col-4 datepicker-full">
                                <label style={{marginBottom:"10px"}}>End Date <span className="required">*</span></label><br/>
                                <ReactDatePicker
                                    placeholderText="End Date"
                                    className="col-12"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    selected={props.packageCatalogueData.dtEndDate || ""}
                                    onChange={(date) => props.onInputChange("dtEndDate", date) }
                                />
                            </div>
                            <div className="col-4">
                                <label style={{marginBottom:"10px"}}>Payment Type <span className="required">*</span></label><br/>
                                <Select
                                    options={props.PackageTypesOptions}
                                    onChange={props.onPackageTypeChange}
                                    value={props.selectedPackageType}
                                />
                            </div>
                            
                            
                            <div className="col-4">
                                <label style={{marginBottom:"10px"}}>Package/Offering Status <span className="required">*</span></label><br/>
                                <Select
                                    options={props.PackageStatusOptions}
                                    onChange={props.onPackageStatusChange}
                                    value={props.selectedPackageStatus}
                                    isDisabled={!props.isEditPackageCatalogue}
                                />
                            </div>
                            <div className="col-4">
                                <label style={{marginBottom:"10px"}}>Type <span className="required">*</span></label><br/>
                                <Select
                                    options={props.sTypeOptions}
                                    onChange={props.onsTypeOptionChange}
                                    value={props.selectedsTypeOption}
                                    isDisabled={props.isEditPackageCatalogue}
                                />
                            </div>
                            {props.selectedsTypeOption.value==="Package"?
                            (
                                <div className="col-4">
                                    <label style={{marginBottom:"10px",marginTop:"10px"}}>Package Delivery <span className="required">*</span></label><br/>
                                    <Select
                                        options={props.packageDeliveryOptions}
                                        onChange={props.onPackageDeliveryChange}
                                        value={props.selectedPackageDeliveryOption}
                                    />
                                </div>
                            ):("")}
                            
                            <div className="col-4">
                                <label style={{marginBottom:"10px",marginTop:"20px"}}><span className="required"> {" "}</span></label>
                                    <div className="float-left" style={{marginRight:"10px",marginTop:"45px"}}>
                                        {props.isEditPackageCatalogue?
                                        (
                                            <Button onClick={props.onSubmitEditPackageCatalogue}>
                                                Update
                                            </Button>
                                        ):(
                                            <Button onClick={props.onSubmitPackageCatalogue}>
                                                Create
                                            </Button>
                                        )}                                         
                                    </div>
                                    <div className="float-left" style={{marginTop:"45px"}}>
                                    <Button
                                        onClick={props.onCancelCreatePackageCatalogue}
                                    >
                                        Cancel
                                    </Button>
                                    </div>
                                    
                            </div>
                         </div>
                    </div>
                    <div className="col-5">
                        <div className="row">
                        <div className="col-6">
                        <label style={{marginBottom:"10px"}}>Description <span className="required">*</span></label><br/>
                            <textarea
                                placeholder="Description"
                                name="sPackageOfferDesc"
                                label="Description"
                                className="w-100 form-control rounded"
                                value={props.packageCatalogueData.sPackageOfferDesc || ""}
                                onChange={({ target: { name, value } }) =>
                                    props.onInputChange(name, value)
                                }
                                style={{minHeight:"125px"}}
                            />
                        </div>
                        <div className="col-6">
                        <label style={{marginBottom:"10px"}}>Inclusions <span className="required">*</span></label><br/>
                            <textarea
                                placeholder="Inclusions"
                                name="sInclusions"
                                label="Inclusions"
                                className="w-100 form-control rounded"
                                value={props.packageCatalogueData.sInclusions || ""}
                                onChange={({ target: { name, value } }) =>
                                    props.onInputChange(name, value)
                                }
                                style={{minHeight:"125px"}}
                            />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}